// extracted by mini-css-extract-plugin
export var active = "_79-a";
export var activeIndicator = "_79-9";
export var disabled = "_79-b";
export var fullWidth = "_79-2";
export var lg = "_79-7";
export var md = "_79-6";
export var redoButtonTabGroup = "_79-0";
export var sm = "_79-5";
export var tabButton = "_79-4";
export var tabButtonsContainer = "_79-1";
export var themeDestructive = "_79-d";
export var themeNormal = "_79-c";
export var themeSuccess = "_79-e";
export var xl = "_79-8";
export var xs = "_79-3";